import { render } from "./DataAndEvolutionRowValue.vue?vue&type=template&id=f28db8f0&scoped=true"
import script from "./DataAndEvolutionRowValue.vue?vue&type=script&lang=js"
export * from "./DataAndEvolutionRowValue.vue?vue&type=script&lang=js"

import "./DataAndEvolutionRowValue.vue?vue&type=style&index=0&id=f28db8f0&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f28db8f0"]])

export default __exports__